<div class="general">
    <div class="general-fix">
      <div class="img-size">
        <img src="assets/logo-dabnet.png" alt="" />
      </div>
      <div class="title-p1">404!</div>
      <div class="title-p2">Üzgünüz.</div>
      <div class="title-p2">Dabnet Kamu Uygulaması İçin Yetkiniz bulunamadı...</div>
      <a class="title-p3"(click)="logout()">
       Çıkış yap
      </a>
    </div>
  </div>
  